import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  Pipe,
  PipeTransform,
  LOCALE_ID,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from "@angular/forms";
import { ApiService } from "src/app/services/api.service";
import { Task } from "src/app/models/task";
import { NgxMaterialTimepickerComponent, NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { first, switchMap, tap } from "rxjs/operators";
import { UserContextService } from "src/app/services/user-context.service";
import { QueryParameter } from "src/app/helpers/queryParameter";
import { QueryFilter } from "src/app/helpers/queryFilter";
import { Observable, Subscription } from "rxjs";
import { Moment } from "moment";
import * as moment from "moment";
import { GanttStatic } from "dhtmlx-gantt";
import { formatDate, AsyncPipe } from "@angular/common";
import { StatutOperOfPipe } from "./StatutOperOfPipe";
import { MatButton } from "@angular/material/button";
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from "@angular/material/datepicker";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatOption } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
import { MatInput } from "@angular/material/input";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Pipe({
    name: "tpsHours",
    standalone: true
})
export class TpsHoursPipe implements PipeTransform {
  transform(value: number): number {
    return value ? Math.floor(value) : 0;
  }
}
@Pipe({
    name: "tpsMin",
    standalone: true
})
export class TpsMinPipe implements PipeTransform {
  transform(value: number): number {
    const min = value ? Math.floor((value - Math.floor(value)) * 60) : 0;
    return min;
  }
}
@Pipe({
    name: "tpsSec",
    standalone: true
})
export class TpsSecPipe implements PipeTransform {
  transform(value: number): number {
    const minutes = Math.floor((value - Math.floor(value)) * 60);
    return minutes ? Math.floor((minutes - Math.floor(minutes)) * 60) : 0;
  }
}
@Component({
    selector: "app-lightbox-op",
    templateUrl: "./lightbox-op.component.html",
    styleUrls: ["./lightbox-op.component.scss"],
    standalone: true,
    imports: [
    MatDialogTitle,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatTabGroup,
    MatTab,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelect,
    MatOption,
    MatCheckbox,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    NgxMaterialTimepickerModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    AsyncPipe,
    StatutOperOfPipe,
    TpsHoursPipe,
    TpsMinPipe,
    TpsSecPipe
],
})
export class LightboxOpComponent implements OnInit {
  instance: any;
  instanceForm: UntypedFormGroup = this.fb.group({
    Centre: new UntypedFormControl({ value: null, disabled: true }),
    Poste: new UntypedFormControl({ value: null, disabled: false }),
    TpsFabr: new UntypedFormControl({ value: null, disabled: true }),
    TpsPrepa: new UntypedFormControl({ value: null, disabled: true }),
    StatutOper: new UntypedFormControl({ value: null, disabled: true }),
    TpsFabrReel: new UntypedFormControl({ value: null, disabled: true }),
    TpsPrepaReel: new UntypedFormControl({ value: null, disabled: true }),
    QteMo: new UntypedFormControl({ value: null, disabled: true }),
    CapacitePoste: new UntypedFormControl({ value: null }),
    QteLancee: new UntypedFormControl({ value: null, disabled: true }),
    QteBonne: new UntypedFormControl({ value: null, disabled: true }),
    DateDebutJalon: new UntypedFormControl({ value: null, disabled: true }),
    DateFinJalon: new UntypedFormControl({ value: null, disabled: true }),
    UserField1: new UntypedFormControl({ value: null, disabled: false }),
    UserField2: new UntypedFormControl({ value: null, disabled: false }),
    UserField3: new UntypedFormControl({ value: null, disabled: false }),
    UserField4: new UntypedFormControl({ value: null, disabled: false }),
    UserField5: new UntypedFormControl({ value: null, disabled: false }),
    UserField6: new UntypedFormControl({ value: null, disabled: false }),
    UserField7: new UntypedFormControl({ value: null, disabled: false }),
    UserField8: new UntypedFormControl({ value: null, disabled: false }),
    UserField9: new UntypedFormControl({ value: null, disabled: false }),
    UserField10: new UntypedFormControl({ value: null, disabled: false }),
    UserField11: new UntypedFormControl({ value: null, disabled: false }),
    UserField12: new UntypedFormControl({ value: null, disabled: false }),
    UserField13: new UntypedFormControl({ value: null, disabled: false }),
    UserField14: new UntypedFormControl({ value: null, disabled: false }),
    UserField15: new UntypedFormControl({ value: null, disabled: false }),
    UserField16: new UntypedFormControl({ value: null, disabled: false }),
    UserField17: new UntypedFormControl({ value: null, disabled: false }),
    UserField18: new UntypedFormControl({ value: null, disabled: false }),
    UserField19: new UntypedFormControl({ value: null, disabled: false }),
    UserField20: new UntypedFormControl({ value: null, disabled: false }),
    Ratio: new UntypedFormControl({ value: true, disabled: false }),
  });
  constructor(
    public dialogRef: MatDialogRef<LightboxOpComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { task: Task; param: any; gantt: GanttStatic },
    private fb: UntypedFormBuilder,
    private apiService: ApiService,
    private userContext: UserContextService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  @ViewChild("timeDebutJalon", { static: true })
  timeDebutJalon: NgxMaterialTimepickerComponent;
  @ViewChild("timeFinJalon", { static: true })
  timeFinJalon: NgxMaterialTimepickerComponent;
  postes$: Observable<any>;
  httpResult$: Subscription;
  userFields: any;
  indicesUserfields = [...Array(20).keys()].map((i) => i + 1);
  indicesUserfieldsToShowOnMainTab = this.data.param.NbChampsUserOpOnMainTab ? [...Array(this.data.param.NbChampsUserOpOnMainTab).keys()].map((i) => i + 1) : [];
  ngOnInit() {
    const query = new QueryParameter();
    query.queryFilters = [];
    const filter: QueryFilter = {
      Name: "SeqOp",
      QueryOperator: "Equal",
      Value: this.data.task.SeqOp,
    };
    query.queryFilters.push(filter);
    this.httpResult$ = this.apiService
      .generateHttpRequest(
        null,
        "OperationProduction/" + this.data.task.SeqOp,
        null,
        "GET",
        null
      )
      .pipe(
        first(),
        tap(() => {
          const startTime =
            this.data.task.start_date.getHours().toString() +
            ":" +
            this.data.task.start_date.getMinutes().toString();
          this.timeDebutJalon.updateTime(startTime);
          const endTime =
            this.data.task.end_date.getHours().toString() +
            ":" +
            this.data.task.end_date.getMinutes().toString();
          this.timeFinJalon.updateTime(endTime);
          this.timeDebutJalon.timeChanged.subscribe((time) => {
            this.data.task.start_date = this.updateDate(
              this.data.task.start_date,
              time
            );
            this.applyRatio("start");
          });
          this.timeFinJalon.timeChanged.subscribe((time) => {
            this.data.task.end_date = this.updateDate(
              this.data.task.end_date,
              time
            );
            this.applyRatio("end");
          });
        }),
        switchMap((result) => {
          this.instance = result;
          this.instanceForm.patchValue(this.instance);
          if (this.data.task.Poste) {
            this.instanceForm.get("Poste")?.patchValue(this.data.task.Poste);
          }
          const queryPostes = this.apiService.getQueryParamForSiteAndCentre(
            this.userContext.siteConnexion,
            this.instance.Centre
          );
          this.postes$ = this.apiService.getSelect(queryPostes, "poste").pipe();
          return this.apiService.generateHttpRequest(
            query,
            "gantt/getrules",
            null,
            "GET",
            null
          );
        })
      )
      .subscribe((userFields) => {
        this.userFields = userFields;
        for (let i = 1; i <= 20; i++) {
          if (userFields.some((ruleResult) => ruleResult.Index === i)) {
            let fieldValue = userFields.find(
              (ruleResult) => ruleResult.Index === i
            ).Value;
            if (moment(fieldValue, moment.ISO_8601, true).isValid()) {
              userFields.find((ruleResult) => ruleResult.Index === i).Value = formatDate(fieldValue, "dd/MM/yyyy HH:mm:ss", this.locale, undefined);
            }

            this.instanceForm
              .get("UserField" + i)
              .patchValue(
                userFields.find((ruleResult) => ruleResult.Index === i).Value
              );
          }
        }
      });
  }
  /** L'of n'est pas modifiable si le statut est lancé , en cours ou si il est non jalonnable */
  isMovable() {
    return (
      this.data.task.StatutOf !== "L" &&
      this.data.task.StatutOf !== "E" &&
      this.data.task.NonJalonnable !== true
    );
  }
  /**
   * Maintient du ratio
   * @param endOrStart
   * @param difference
   */
  applyRatio(endOrStart) {
    if (this.instanceForm.get("Ratio").value) {
      /** Si ratio préservé alors on met à jour la date de fin en conséquence */
      if (endOrStart === "start") {
        /** On utilise calculateEndDate afin de recalculer la date de fin en tenant compte des jours chomés */
        this.data.task.end_date = this.data.gantt.calculateEndDate(
          this.data.task
        );
        const endTime =
          this.data.task.end_date.getHours().toString() +
          ":" +
          this.data.task.end_date.getMinutes().toString();
        this.timeFinJalon.updateTime(endTime);
      } else if (endOrStart === "end") {
        this.data.task.start_date = this.data.gantt.calculateEndDate({
          start_date: this.data.task.end_date,
          duration: -this.data.task.duration,
        });

        const startTime =
          this.data.task.start_date.getHours().toString() +
          ":" +
          this.data.task.start_date.getMinutes().toString();
        this.timeDebutJalon.updateTime(startTime);
      }
    }
  }
  updateDate(date, time: string) {
    const timeSplitted = time.split(":", 2);
    const finalDate = new Date(date);
    finalDate.setHours(Number(timeSplitted[0]));
    finalDate.setMinutes(Number(timeSplitted[1]));
    return finalDate;
  }
  dateHasChanged(endOrStart, event: any, ratio) {
    const date_start = this.data.task.start_date;
    const date_end = this.data.task.end_date;
    const momentToDate = (event.value as Moment).toDate();
    if (endOrStart === "start") {
      const hours = this.data.task.start_date.getHours();
      const minutes = this.data.task.start_date.getMinutes();
      this.data.task.start_date = momentToDate;
      this.data.task.start_date.setHours(hours);
      this.data.task.start_date.setMinutes(minutes);
      /** Si ratio préservé alors on met à jour la date de fin en conséquence */
      if (ratio) {
        /** On utilise calculateEndDate afin de recalculer la date de fin en tenant compte des jours chomés */
        this.data.task.end_date = this.data.gantt.calculateEndDate(
          this.data.task
        );

        const endTime =
          this.data.task.end_date.getHours().toString() +
          ":" +
          this.data.task.end_date.getMinutes().toString();
        this.timeFinJalon.updateTime(endTime);
      }
    } else if (endOrStart === "end") {
      const hours = this.data.task.end_date.getHours();
      const minutes = this.data.task.end_date.getMinutes();
      this.data.task.end_date = momentToDate;
      this.data.task.end_date.setHours(hours);
      this.data.task.end_date.setMinutes(minutes);
      /** Si ratio préservé alors on met à jour la date de début en conséquence */
      if (ratio) {
        this.data.task.start_date = this.data.gantt.calculateEndDate({
          start_date: this.data.task.end_date,
          duration: -this.data.task.duration,
        });

        const startTime =
          this.data.task.start_date.getHours().toString() +
          ":" +
          this.data.task.start_date.getMinutes().toString();
        this.timeDebutJalon.updateTime(startTime);
      }
    }
    if (this.data.task.start_date >= this.data.task.end_date) {
      alert("la date de début ne peut être supérieure à la date de fin");
      this.data.task.start_date = date_start;
      this.data.task.end_date = date_end;
    }
  }
  close() {
    if (this.data.task.start_date >= this.data.task.end_date) {
      alert("la date de début ne peut être supérieure à la date de fin");
    } else this.dialogRef.close(this.data.task);
  }
  updateData(prop, formValue) {
    this.data.task[prop] = formValue[prop];
  }
  ngOnDestroy(): void {
    this.httpResult$?.unsubscribe();
  }
}
